module.exports = __webpack_public_path__ + "static/apply.4ac612d0.svg";